/** Float noise below this (after cent rounding) is treated as zero. */
export const PRICE_EPSILON = 0.005;

export const roundUpPrice = (price: number, isInt = false) => {
  const result = Math.round((price + Number.EPSILON) * 100) / 100;
  if (!isInt) return result;
  return Math.round(result);
};

/**
 * Round to cents and clamp near-zero float noise so ghost ±0/±1 option lines
 * do not appear in the estimate calculator.
 */
export const sanitizeDeltaPrice = (price: number) => {
  const rounded = roundUpPrice(price);
  return Math.abs(rounded) < PRICE_EPSILON ? 0 : rounded;
};

/** True when the whole-currency displayed amount is non-zero (included = hide). */
export const hasNonZeroDisplayedPrice = (price: number) =>
  Math.abs(Math.round(sanitizeDeltaPrice(price))) >= 1;

export const formatPrice = (price: number, isInt = true) =>
  Intl.NumberFormat('fr-FR', {
    maximumFractionDigits: isInt ? 0 : 2,
    minimumFractionDigits: isInt ? 0 : 2,
    // Align display with roundUpPrice (half-up), not ceil — avoids ±1€ drift
    // between agency and client totals on the same underlying amount.
    roundingMode: isInt ? 'halfExpand' : undefined,
  }).format(roundUpPrice(price));
